import React, { useState, useCallback, useEffect } from "react";
import {CircularProgress,Grid,Button} from "@material-ui/core";
import { useSelector } from "react-redux";
import { pathOr } from "ramda";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Scrollbars } from 'react-custom-scrollbars';

import { FormInput } from "../../../../../";
import { getMassUpdateForm } from "../../../../../../store/actions/module.actions";
import useStyles from "./styles";

const MassUpdate = ({
  modalVisible,
  toggleModalVisibility,
  updateRecords,
  updateLoader,
}) => {
  const [form, setForm] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [updateRecordFields, setUpdateRecordFields] = useState({});
  const { selectedModule } = useSelector((state) => state.modules);
  const [Open, setOpen] = useState(true)
  const classes = useStyles();
  
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const getForm = useCallback(async () => {
    setLoading(true);
    let massUpdateForm = await getMassUpdateForm(selectedModule);
    setForm(
      pathOr([], ["data", "data", "templateMeta", "data"], massUpdateForm),
    );
    setLoading(false);
  }, [selectedModule]);

  useEffect(() => {
    getForm();
  }, [getForm]);

  const renderLoader = () => (
    <div className={classes.progressWrapper}>
      <CircularProgress />
    </div>
  );

  const renderForm = () => {
    return (
      <div className={classes.perSectionWrapper}>
        <Grid container spacing={2}>
          {form &&
            form.map((field) => (
              <Grid item xs={12} sm={6} md={4} key={field.field_key}>
                <FormInput
                  comment=""
                  field={field}
                  key={field.field_key}
                  errors={[]}
                  value={updateRecordFields[field.field_key]}
                  dynamicEnumValue={updateRecordFields[field.parentenum] || ""}

                  small={true}
                  onChange={(val) => {
                    if (field.type === "relate") {
                      setUpdateRecordFields({
                        ...updateRecordFields,
                        [field.name]: val.value,
                        [field.id_name]: val.id,
                      });
                      return;
                    }
                    setUpdateRecordFields({
                      ...updateRecordFields,
                      [field.field_key]: val,
                    });
                  }}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    );
  };

  return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={Open}
        onClose={handleClose}
        style={{minHeight : '60vh !important'}}
        aria-labelledby="max-width-dialog-title"
        className={classes.dialog_new}
      >
        <DialogTitle id="max-width-dialog-title">Mass Update</DialogTitle>
       
          <DialogContent>
          {loading ? renderLoader() : renderForm()}
          </DialogContent>
               
          <DialogActions>
          {!updateLoader && (
            <Button
              variant="contained"
              onClick={toggleModalVisibility}
              color="primary"
              size="medium"
              fullWidth
              disabled={updateLoader}
              disableElevation
              style={{ display:"inline-block", justifyContent:"flex-end",margin: 5, width: "100px", color: "White" }}
            >
              {"Cancel"}
            </Button>
          )}
          {
            updateLoader ? <Button
              variant="contained"
              onClick={() => updateRecords(updateRecordFields)}
              color="primary"
              size="medium"
              fullWidth
              //disabled={true}
              disableElevation
              style={{ margin: 5, width: "100px", color: "White" }}
            >
              Saving <CircularProgress size={25} style={{ marginLeft: 10, color: "White" }} /> </Button>
              : <Button
                variant="contained"
                onClick={() => updateRecords(updateRecordFields)}
                color="primary"
                size="medium"
                fullWidth
                //disabled={updateLoader}
                disableElevation
                style={{ margin: 5, width: "100px", color: "White" }}
              > Save </Button>
          }  
          </DialogActions>
        </Dialog>       
  );
};

export default MassUpdate;
